export function setNewObjectToTable(dataObject, deselectedData) {
    // Filter out the lines based on deselectedData
    const filteredLines = dataObject.data.lines.filter(lineItem => 
        !deselectedData.some(deselectedItem => deselectedItem.name === lineItem.line)
    );

    // Calculate the new total by subtracting the total from deselectedData from dataObject.data.total
    const subtractedTotal = deselectedData.reduce((acc, curr) => {
        return acc - curr.total;
    }, dataObject.data.total);

    // Return a new object with updated lines and total
    return {
        ...dataObject,
        data: {
            ...dataObject.data,
            lines: filteredLines,
            total: subtractedTotal
        }
    };
}
